import React from 'react';
import { reduxForm, Field, change as FormChange } from 'redux-form';
import { connect } from 'react-redux';
import { map } from 'ramda';
import RichTextEditor from 'react-rte';

import LoggedIn from './LoggedIn';
import FlashMessage from './FlashMessage';

import { saveHorseProcess } from '../actions/processQueueActions';

class EnhancedHorseEditForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        textAreaValue: RichTextEditor.createValueFromString(props.initialValues.enhanced_text_area, 'html'),
        editMode: false,
      };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialValues.hip !== this.props.initialValues.hip) {
            this.setState({
                textAreaValue: RichTextEditor.createValueFromString(this.props.initialValues.enhanced_text_area, 'html'),
            });
        }
    }

    onWysiwigChange = (value) => {
        this.props.changeTextArea('enhanced_text_area', value.toString('html'));
        this.setState({
            textAreaValue: value,
        });
    };

    setEditMode(mode) {
        this.setState({ editMode: mode });
    }

    renderInput = ({
        input,
        label,
        type,
        helpText,
    }) => (
        <div className="form-group">
            <label className="col-sm-3 control-label">
                {label}
            </label>
            <div className="col-sm-9">
                <input {...input} type={type} className="form-control" placeholder={label} />
                <p className="help-block" id="help-block">{helpText}</p>
            </div>
        </div>
    );

    renderWYSIWIG = ({
        input,
        label,
        type,
        helpText,
    }) => (
        <div className="form-group"  style={{ display: 'none' }}>
            <label className="col-sm-3 control-label">
                {label}
            </label>
            <div className="col-sm-9">
                <textarea {...input} name="enhanced_text_area" type={type} rows="6" cols="50" className="form-control" placeholder={label} />
                <p className="help-block" id="help-block">{helpText}</p>
            </div>
        </div>
    );

    renderTextbox = ({
        input,
        label,
        type,
        helpText,
    }) => (
        <div className="form-group">
            <label className="col-sm-3 control-label">
                {label}
            </label>
            <div className="col-sm-9">
                <textarea {...input} type={type} rows="6" cols="50" className="form-control" placeholder={label} />
                <p className="help-block" id="help-block">{helpText}</p>
            </div>
        </div>
    );


    renderCheckbox = ({
        input,
        label,
        type,
    }) => (
        <div className="form-check form-check-inline">
            <input className="form-check-input" type={type} {...input} />
            <label className="form-check-label">{label}</label>
        </div>
    );

    render() {
        const { horse, saveHorse } = this.props;
        const saleIsNovember = true//global.drupalSettings.catalogues.sale_name.indexOf('November') !== -1;

        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
                {label: 'Italic', style: 'ITALIC'},
                {label: 'Underline', style: 'UNDERLINE'}
            ],
            BLOCK_TYPE_BUTTONS: [
                {label: 'UL', style: 'unordered-list-item'},
                {label: 'OL', style: 'ordered-list-item'}
            ]
        };
        const editForm = !this.state.editMode ? (<></>) : (
            <div className="row">
                <div className="col">
                    <form
                        className="form-horizontal"
                        style={{
                            
                        }}
                        onSubmit={(e) => {
                            e.preventDefault();
                            saveHorse(horse, 'enhancedHorseEdit');
                        }}
                    >
                        <Field
                            component={this.renderInput}
                            type="text"
                            value=""
                            name="enhanced_photo_caption"
                            id="enhanced_photo_caption"
                            label="Photo Caption"
                            helpText="If desired, add a caption for the horse photo. Leave blank if not desired or no photo should be present."
                        />
                        <div className="form-group">
                            <label className="col-sm-3 control-label">
                                HTML Area Text
                            </label>
                            <div className="col-sm-9">
                                <RichTextEditor
                                    value={this.state.textAreaValue}
                                    onChange={this.onWysiwigChange}
                                    toolbarConfig={toolbarConfig}
                                />
                            </div>
                        </div>
                        <Field
                            component={this.renderWYSIWIG}
                            type="text"
                            value=""
                            name="enhanced_text_area"
                            id="enhanced_text_area"
                            label="HTML Area Text"
                            helpText=""
                        />
                        {!saleIsNovember &&
                            <Field
                            component={this.renderTextbox}
                            type="text"
                            value=""
                            name="enhanced_watchmaker"
                            id="enhanced_watchmaker"
                            label="Full Watchmaker Analysis"
                            helpText="Accepts HTML format (e.g. <strong>NAME</strong>)."
                            />
                        }
                        <Field
                            component={this.renderInput}
                            type="text"
                            value=""
                            name="enhanced_racing_stats"
                            id="enhanced_racing_stats"
                            label="Racing Stats Link"
                            helpText=""
                        />
                        {saleIsNovember &&
                            <Field
                            component={this.renderInput}
                            type="text"
                            value=""
                            name="enhanced_stallion_register"
                            id="enhanced_stallion_register"
                            label="Stallion Register"
                            helpText=""
                            />
                        }
                        <Field
                            component={this.renderInput}
                            type="text"
                            value=""
                            name="enhanced_race_replays"
                            id="enhanced_race_replays"
                            label="Race Replays Link"
                        />
                        {saleIsNovember &&
                            <Field
                            component={this.renderInput}
                            type="text"
                            value=""
                            name="enhanced_featured_video"
                            id="enhanced_featured_video"
                            label="Featured Video Link"
                            helpText="Enter the embed link from Youtube. (i.e. https://www.youtube.com/embed/gcpFOYY3V10?rel=0&amp;showinfo=0"
                            />
                        }
                        {saleIsNovember &&
                            <Field
                            component={this.renderInput}
                            type="text"
                            value=""
                            name="enhanced_5x_pedigree"
                            id="enhanced_5x_pedigree"
                            label="5x Pedigree Link"
                            helpText="Enter an external link or one pointing toward server upload"
                            />
                        }
                        {
                            <Field
                            component={this.renderTextbox}
                            type="text"
                            value=""
                            name="enhanced_bonus_content"
                            id="enhanced_bonus_content"
                            label="Bonus Content Links"
                            helpText="Enter each url as Display Title>URL (i.e. Google>http://google.com). Separate each separate link by a comma with no spaces."
                            />
                        }
                        {!saleIsNovember &&
                            <Field
                            component={this.renderCheckbox}
                            type="checkbox"
                            value=""
                            name="enhanced_ragozin"
                            id="enhanced_ragozin"
                            label="Ragozin"
                            />
                        }
                        {saleIsNovember &&
                            <Field
                            component={this.renderCheckbox}
                            type="checkbox"
                            value=""
                            name="enhanced_alan_porter"
                            id="enhanced_alan_porter"
                            label="Alan Porter"
                            />
                        }
                        {!saleIsNovember &&
                            <Field
                            component={this.renderCheckbox}
                            type="checkbox"
                            value=""
                            name="enhanced_thoroughmanager"
                            id="enhanced_thoroughmanager"
                            label="Thoroughmanager"
                            />
                        }
                        {!saleIsNovember &&
                            <Field
                            component={this.renderCheckbox}
                            type="checkbox"
                            value=""
                            name="enhanced_thorograph"
                            id="enhanced_thorograph"
                            label="Thoro-graph"
                            />
                        }
                        <Field
                            component={this.renderCheckbox}
                            type="checkbox"
                            value=""
                            name="pp_enabled"
                            id="pp_enabled"
                            label="Enable PP"
                        />
                        <FlashMessage />
                        <div className="">
                            <button className="btn btn-primary" type="submit">
                                Save
                            </button>
                            <br />
                            <br />
                        </div>
                    </form>
                   
                </div>
            </div>
        );

        return (
            <LoggedIn>
                <div>
                    <button className="btn btn-link" onClick={ () => this.setEditMode(!this.state.editMode) }>Edit</button>
                    {editForm}
                </div>
            </LoggedIn>
        )
    }
};

EnhancedHorseEditForm = reduxForm({
    // a unique name for the form
    form: 'enhancedHorseEdit',
    destroyOnUnmount: false,
    enableReinitialize: true,
})(EnhancedHorseEditForm);

const mapState = () => ({});

const mapDispatch = (dispatch) => {
    return {
        saveHorse(horse, form) {
            dispatch(saveHorseProcess(horse, form));
        },
        changeTextArea: (field, value) => {
            dispatch(FormChange('enhancedHorseEdit', field, value));
        },
    };
};

export default connect(mapState, mapDispatch)(EnhancedHorseEditForm);
